import React, { createElement } from 'react';
import { Select } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
class UnitSearch extends React.Component {
    static defaultProps = {
        queryList: [],
        split: '/',
    };
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            tip: '',
        };
    }
    handleChange = (val, option) => {
        this.triggerChange(val, option);
        setTimeout(() => {
            let finalValue = val;
            let finalOption = option;
            if (this.props.setInfo && typeof this.props.setInfo === 'function') {
                const temp = this.props.setInfo(val, option);
                if (temp) {
                    this.setState({ tip: temp, query: '' });
                    finalValue = undefined;
                    finalOption = {};
                }
                else {
                    this.setState({ tip: '' });
                }
                this.triggerChange(finalValue, finalOption);
            }
        }, 100);
    };
    triggerChange = (changedValue, option) => {
        const { onChange } = this.props;
        if (onChange) {
            onChange(changedValue, option);
        }
    };
    changeQuery = (data) => {
        const query = data ? data.replace(/[\u200b-\u200f\uFEFF\u202a-\u202e]/g, '').trim() : undefined;
        this.setState({
            query,
        });
    };
    clear = () => {
        this.changeQuery('');
        this.handleChange(undefined, {});
    };
    dealFocus = () => {
        const { value } = this.props;
        if (!value) {
            this.setState({
                query: '',
            });
        }
    };
    render() {
        const { query, tip } = this.state;
        const { placeholder, queryList, split, selectQueryStyle = {}, value } = this.props;
        let placeholderStr = placeholder;
        if (!placeholderStr) {
            const holderList = queryList.map((item) => item.label);
            placeholderStr = `请输入${holderList.join(split)}`;
        }
        const suffixIcon = !value ? (createElement(SearchOutlined, { onClick: () => {
                this.clear();
            } })) : (createElement(CloseOutlined, { onClick: () => {
                this.clear();
            } }));
        return (createElement("div", { className: "unit-search-material" },
            createElement(Select, { showSearch: true, value: value, placeholder: placeholderStr, filterOption: false, onSearch: this.changeQuery, onSelect: this.handleChange, onFocus: this.dealFocus, notFoundContent: null, style: { width: '100%', position: 'relative', ...selectQueryStyle }, getPopupContainer: (triggerNode) => triggerNode.parentNode, suffixIcon: suffixIcon, optionLabelProp: "label" }, query &&
                queryList.map((item) => (createElement(Select.Option, { title: item.title || `选择在${item.label}中查询『${query}』`, value: `${item.key}_${query}`, key: `${item.key}_${query}`, className: "test", label: `${item.label}为 ${query}` },
                    createElement("div", null, `在${item.label}中查询『${query}』`))))),
            tip && createElement("span", { style: { color: '#ff571a', position: 'absolute', left: 0, top: 34 } }, tip)));
    }
}
export default UnitSearch;
